module.exports = __webpack_public_path__ + "static/media/card-1.6ee66b2c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-1.jpeg
// module id = 347
// module chunks = 0